import { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { useSite } from "@/context/SiteContentContext";
import SiteLayout from "@/components/site/SiteLayout";
import { SectionTag } from "@/components/site/Reveal";
import { legalContent } from "@/i18n/legal";

export default function Legal({ type }) {
  const params = useParams();
  const kind = type || params.type || "privacy";
  const { t, lang, dir } = useLang();
  const { settings } = useSite();
  const Back = dir === "rtl" ? ArrowRight : ArrowLeft;
  const doc = (legalContent[lang] || legalContent.ar)[kind] || legalContent.ar.privacy;
  const override = (settings[`legal_${kind}_${lang}`] || "").trim();

  useEffect(() => { window.scrollTo(0, 0); }, [kind]);

  return (
    <SiteLayout>
      <section className="section-pad pt-14" data-testid="legal-page">
        <div className="mx-auto max-w-3xl px-5 sm:px-8">
          <SectionTag>{kind === "terms" ? t.legal.terms : t.legal.privacy}</SectionTag>
          <h1 className="text-4xl sm:text-5xl font-extrabold mt-5 mb-2">{doc.title}</h1>
          <p className="text-sm text-slate-500 mb-10">{t.legal.updated}: {doc.updated}</p>

          {override ? (
            <div className="prose prose-invert max-w-none text-slate-300 leading-relaxed whitespace-pre-line" data-testid="legal-override">
              {override}
            </div>
          ) : (
            <div className="space-y-8">
              {doc.sections.map((s, i) => (
                <div key={i} data-testid={`legal-section-${i}`}>
                  <h2 className="text-xl font-bold mb-2 text-primary">{s.h}</h2>
                  <p className="text-slate-400 leading-relaxed text-base">{s.p}</p>
                </div>
              ))}
            </div>
          )}

          <Link to="/" className="mt-12 inline-flex items-center gap-2 rounded-full border border-white/15 px-6 py-3 text-sm font-bold hover:bg-white/5 transition-colors" data-testid="legal-back">
            <Back size={16} /> {t.legal.backHome}
          </Link>
        </div>
      </section>
    </SiteLayout>
  );
}
